
import { Component, Vue, Prop } from "vue-property-decorator";
import StudentItem from "./StudentItem.vue";
@Component({
  components: {
    StudentItem
  }
})
export default class Student extends Vue {
  @Prop({ required: true }) private list!: any;
}
